var map = {
	"./de.json": [
		5911,
		292
	],
	"./en-GB.json": [
		4531,
		531
	],
	"./es-ES.json": [
		3207,
		207
	],
	"./fr-FR.json": [
		4911,
		911
	],
	"./it.json": [
		8437,
		437
	],
	"./pt-BR.json": [
		8463,
		463
	],
	"./pt-PT.json": [
		4363,
		363
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4900;
module.exports = webpackAsyncContext;